export default __webpack_public_path__ + "static/media/calibra-cements-flowchart.b6d0d4cc.svg";